import { useNavigate } from "react-router-dom";
import { ROUTES } from "#root/routes/constants";
import ActionCards from "#root/components/ActionCards";
import { Breadcrumbs } from "#root/components/Breadcrumbs";

const EmcMerrgeSettings: React.FC = () => {
    const navigate = useNavigate();

    const actionCards = [
        {
          image: "superadmin-user-management",
          title: "SuperAdmin User Management",
          onClick: () => navigate(ROUTES.EMC_MERRGE_SETTINGS.SUPERADMIN_USER_MANAGEMENT),
        },
      ];
    
      return (
        <div className="emc-merrge-settings">
          <div className="emc-page-header">
                <div className="emc-page-header__top-row">
                    <div className="emc-page-header__breadcrumbs">
                        <Breadcrumbs/>
                    </div>
                </div>
                <div className="emc-page-header__title">
                    <h2>EMC MERRGE Settings <div className="divider" /></h2>
                </div>
            </div>
          
          <ActionCards cards={actionCards} />
        </div>
      );
};

export default EmcMerrgeSettings;